<template>
  <v-app>
    <!-- 로딩 스피너 -->
    <v-dialog persistent width="300" v-model="$store.state.loading">
      <div class="loading-wrap">
        <div id="spinner"></div>
      </div>
    </v-dialog>

    <!-- 비로그인: 로그인 라우트만 렌더 -->
    <template v-if="!$store.state.token">
      <router-view />
    </template>

    <!-- 로그인 후 레이아웃 -->
    <DefaultLayout v-else />
  </v-app>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";

export default {
  components: { DefaultLayout },
};
</script>

<style>
/* 폰트 (legacy NotoSans — sidebar section label 등 일부에서 사용) */
@font-face {
  font-family: "notosans";
  src: url("./assets/font/NotoSansKR-Bold.otf");
}
@font-face {
  font-family: "notosansmedium";
  src: url("./assets/font/NotoSansKR-Medium.otf");
}
@font-face {
  font-family: "notosanslight";
  src: url("./assets/font/NotoSansKR-Light.otf");
}
@font-face {
  font-family: "notosansregular";
  src: url("./assets/font/NotoSans-Regular.woff2");
}

/* 로딩 스피너 */
.loading-wrap {
  width: 200px;
  height: 200px;
  margin: 20px auto;
  background: transparent;
}

#spinner {
  margin: calc(50% - 25px) auto;
  width: 80px;
  height: 80px;
  box-sizing: border-box;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 100%;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

/* ── 공통 페이지 레이아웃 ── */
.page-wrap {
  padding: 16px;
}
@media (min-width: 600px) {
  .page-wrap { padding: 24px; }
}
@media (min-width: 960px) {
  .page-wrap { padding: 32px 40px; }
}

.page-title {
  font-family: notosans;
  font-size: 20px;
  margin: 0 0 4px;
}
@media (min-width: 600px) {
  .page-title { font-size: 24px; }
}

.page-subtitle {
  font-family: notosans;
  font-size: 13px;
  color: #b4b4b4;
  margin: 0 0 24px;
}

/* ── 반응형 테이블 ── */
.table-wrap {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid rgb(190, 190, 190);
  border-radius: 4px;
}

.table-wrap table {
  border-spacing: 0;
  min-width: 900px;
  width: 100%;
  text-align: center;
}

/* ── 플렉스 그리드 ── */
.flex-wrap-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: flex-start;
}

.flex-grow {
  flex: 1 1 280px;
}

/* ── 반응형 서브 섹션 ── */
.section-block {
  margin-bottom: 24px;
}

/* ── 탭 스크롤 ── */
.tabs-scroll-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* ── 검색 바 ── */
.search-bar-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-top: 16px;
}
</style>
